
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"238","height":"337","viewBox":"0 0 238 337","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"fill":"#D2232A","fill-rule":"evenodd"}},[_c('path',{attrs:{"d":"M35.47 108.835c-3.856-5.505-7.708-10.963-11.831-16.269-3.633-4.675-7.401-9.714-7.401-15.934 0-5.165 3.004-10.228 8.637-10.228 4.286 0 8.014 3.142 9.008 7.289.687 2.87 2.507 2.908 3.321 0 1.19-4.243 4.473-7.251 8.97-7.251 5.74 0 8.713 4.984 8.713 10.263 0 6.165-3.897 11.417-7.53 16.03-4.136 5.248-8.018 10.653-11.887 16.1"}}),_c('text',{attrs:{"font-family":"Roboto-Bold, Roboto","font-size":"59","font-weight":"bold","transform":"translate(13.5 2.404)"}},[_c('tspan',{attrs:{"x":"2.651","y":"55"}},[_v('A')])]),_c('path',{attrs:{"d":"M202.535 227.974c3.855 5.505 7.707 10.963 11.83 16.269 3.634 4.675 7.402 9.714 7.402 15.934 0 5.165-3.005 10.227-8.637 10.227-4.286 0-8.014-3.141-9.008-7.288-.688-2.87-2.507-2.908-3.322 0-1.19 4.242-4.472 7.251-8.97 7.251-5.74 0-8.712-4.984-8.712-10.264 0-6.164 3.896-11.416 7.53-16.028 4.135-5.249 8.018-10.654 11.887-16.101"}}),_c('text',{attrs:{"font-family":"Roboto-Bold, Roboto","font-size":"59","font-weight":"bold","transform":"rotate(180 112.252 167.202)"}},[_c('tspan',{attrs:{"x":"2.651","y":"55"}},[_v('A')])]),_c('g',[_c('path',{attrs:{"d":"M119.316 210.404c-7.69-10.898-15.372-21.704-23.595-32.207-7.247-9.255-14.761-19.232-14.761-31.545 0-10.225 5.992-20.248 17.226-20.248 8.547 0 15.983 6.22 17.964 14.429 1.372 5.681 5 5.757 6.625 0 2.373-8.398 8.92-14.355 17.89-14.355 11.446 0 17.375 9.867 17.375 20.32 0 12.202-7.772 22.6-15.019 31.731-8.246 10.39-15.99 21.092-23.705 31.875"}})])])])
          )
        }
      }
    